<template>
    <div>
        <span class="link-text" @click="getdata">添加</span>
        <el-dialog
            title="添加关联文章"
            :visible.sync="showdialog"
            v-dialogDrag
            width="1200px">

            <div class="expert-box">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <!-- <el-form-item label="楼盘名称">
                            <el-autocomplete v-model="form.project" 
                                value-key="name" 
                                placeholder="输入楼盘名称" 
                                clearable
                                size="mini"
                                :fetch-suggestions="querySearchAsync"  
                                @select="handleSelect">
                            </el-autocomplete>
                        </el-form-item> -->
                        <el-form-item label="文章名称">
                            <el-input v-model="form.name" placeholder="请输入文章名称"></el-input>
                        </el-form-item>
                        <el-form-item label="类型">
                            <el-select v-model="form.types" placeholder="文章类型" size="mini">
                                <el-option :label="item" :value="item" v-for="(item, index) in atypes" :key="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="title" label="标题" show-overflow-tooltip=""></el-table-column>
                        <el-table-column prop="type" label="类型" align="center"></el-table-column>
                        <el-table-column prop="projectid" label="关联楼盘" width="220">
                            <template slot-scope="s">
                                <div class="flex-box">
                                    <span class="text projectname" v-if="s.row.project">{{s.row.project.name}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="click" label="阅读量" align="center"></el-table-column>
                        <el-table-column prop="zanlen" label="点赞" align="center"></el-table-column>
                        <el-table-column prop="putaway" label="状态" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="150">
                            <template slot-scope="s">
                                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                                <el-button type="primary" size="mini" @click="setGuanlian(s.row)" plain>关联</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'ProjectExpert',
    data() {
        return {
            showdialog: false,
            form: {
                projectid: '',
                name: '',
                types: '',
            },
            atypes: ['不限', '动态', '点评'],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            tabledata: [],
        }
    },
    props: {
        id: {
            type: String,
            default: ''
        },
        city:{
            type: String,
            default:''
        }
    },
    methods: {
        setGuanlian(row) {
            if (row.project){
                this.$confirm('是否确定取消'+row.project.name+"的关联").then(
                    confirm=>{
                        var params = {
                            id: row._id['$oid'],
                            projectid: this.id,
                        }
                        this.$api.ProjectDynamicSetProject(params).then(
                            data=>{
                                this.$message.success(data);
                                this.showdialog = false;
                            }
                        )
                    },
                    cancel=>{}
                )
                return;
            }
            var params = {
                id: row._id['$oid'],
                projectid: this.id,
            }
            this.$api.ProjectDynamicSetProject(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
        },
        putaway(row) {
            var params = {
                id: row._id['$oid'],
                putaway: !row.putaway
            }
            this.$api.putAwayProjectDynamic(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTableData();
                }
            )
        },
        getdata() {
            this.showdialog = true;
            this.pageNo = 1;
            this.getTableData();
        },
        getTableData() {
            var params = {
                projectid: this.form.projectid,
                name: this.form.name,
                types: this.form.types,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                city:this.city,
            }
            this.$api.getProjectDynamicList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata = list;
                    this.total = total;
                }
            )
        },
        confirm() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
        querySearchAsync(queryString, cb) {
            if (this.loading) return;
            console.log(queryString)
            var params = {
                name: queryString||'',
                region: '',
                price: '',
                pageNo: 1,
                pagesize: 5,
            }
            this.loading = true;
            this.$api.getProjectList(params).then(
                data=>{
                    this.loading = false;
                    let {list} = data;
                    cb(list);
                }
            )
        },
        handleSelect(item) {
            this.form.projectid = item._id['$oid'];
        },
    },
}
</script>

<style lang="scss" scoped>
.expert-box{
    text-align: left;
}
</style>